import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import BlogLayout from "../../components/BlogLayout";

const BlogPage2 = () => (
  <BlogLayout
    postId={7221}
    title="The Anatomy of High-Performing Teams – Part 2"
    date="Aug 5, 2024"
    heroImage="Blog2.png"
  >
    <Box>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        A leader can't achieve success alone or merely by pulling together
        individuals with the right mix of skills. Join me as I continue to
        discuss the strategies required to build a high-performing team capable
        of taking the organization to the next level.
      </Typography>
    </Box>
    <Box>
      <Typography
        variant="h4"
        sx={{
          fontSize: { xs: "1.5rem", md: "1.875rem" },
          fontWeight: 700,
          color: "text.primary",
          mb: 3,
        }}
      >
        Too Assertive or Not Assertive Enough?
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        Leadership is all about striking the right balance. It's about being
        firm but friendly and setting clear goals while being a dependable and
        respected figure. A leader guides the way, keeps the team steady, and
        trusts them to handle the rest. You don't have to be tough to be
        assertive. In fact, being respected and liked can go together. A key to
        being a well-liked leader is competence — knowing your stuff and how to
        get it done. These traits aren't and shouldn't be considered mutually
        exclusive.
      </Typography>
    </Box>
    <Box>
      <Typography
        variant="h4"
        sx={{
          fontSize: { xs: "1.5rem", md: "1.875rem" },
          fontWeight: 700,
          color: "text.primary",
          mb: 3,
        }}
      >
        Embracing Race &amp; Gender Heterogeneity
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        We embrace individuals of different races, genders, religions,
        ethnicities and more in our team. The collective knowledge and
        experiences that our diverse workforce brings are instrumental in
        increasing effectiveness by reconceiving tasks or processes. When
        leaders seize the opportunity to incorporate diverse ideas into
        improving the core work, it's time for celebration!
      </Typography>
    </Box>
    <Box>
      <Typography
        variant="h4"
        sx={{
          fontSize: { xs: "1.5rem", md: "1.875rem" },
          fontWeight: 700,
          color: "text.primary",
          mb: 3,
        }}
      >
        A Culture of Recognition
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        Recognizing victories, big and small, is an integral part of keeping
        team morale high. Every effort by high-performing team members within my
        team is acknowledged and appreciated at our town hall. Recognition isn't
        just about boosting individuals or teams; it's about igniting motivation
        across the board.
      </Typography>
    </Box>
    <Box>
      <Typography
        variant="h4"
        sx={{
          fontSize: { xs: "1.5rem", md: "1.875rem" },
          fontWeight: 700,
          color: "text.primary",
          mb: 3,
        }}
      >
        Go An Extra Mile to Motivate the Team
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        Clear communication of roles and responsibilities unlocks the full
        potential of a team. A leader's commitment to transparency fuels this
        alignment and ensures everyone understands their role in achieving
        goals. An approachable leader can turn challenges and frustration into
        solutions by providing tools or advice to make their job easier.
      </Typography>
    </Box>
    <Box>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        As I wrap up this blog, I'd like to leave you with a simple thought:
        together, we're a force. Whether you're leading a team, kicking off a
        project, or just trying to make a difference — remember, it's the
        collective hustle that drives progress. Let passion, purpose, and heart
        guide you toward your goals!
      </Typography>
    </Box>
  </BlogLayout>
);

export default BlogPage2;
